import { CreateApiKeyRequest } from './api-keys.model';

const CONTEXT = '[ApiKeys]';

export class GetAllApiKeys {
  static readonly type = `${CONTEXT} Get All Api Keys`;
}

export class CreateApiKey {
  static readonly type = `${CONTEXT} Create Api Key`;
  constructor(public payload: CreateApiKeyRequest) {}
}

export class DeleteApiKey {
  static readonly type = `${CONTEXT} Delete Api Key`;
  constructor(public id: number) {}
}

export class UpdateApiKey {
  static readonly type = `${CONTEXT} Update Api Key`;
  constructor(
    public id: number,
    public payload: CreateApiKeyRequest,
  ) {}
}
